import { render, staticRenderFns } from "./BaseStatusColorPicker.vue?vue&type=template&id=1561cd28&scoped=true&lang=pug&"
import script from "./BaseStatusColorPicker.vue?vue&type=script&lang=js&"
export * from "./BaseStatusColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./BaseStatusColorPicker.vue?vue&type=style&index=0&id=1561cd28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1561cd28",
  null
  
)

export default component.exports